<zaeper-dashboard-layout
  [dashboardLayout]="dashboardLayout"
  branding="/images/zaeper_logo_z.svg"
  [navItems]="navItems"
>
  <ng-template zTemplate="topBarLeft">
    <div class="flex items-center h-full px-4 py-2">
      <img src="/images/developers_logo.svg" class="h-full max-h-8" />
    </div>
  </ng-template>

  <ng-template zTemplate="topBarRight">
    <div class="flex items-center gap-2">
      <zaeper-dark-mode-toggle></zaeper-dark-mode-toggle>
      <app-user-menu></app-user-menu>
      <p-button
        (onClick)="openAppSwitcher()"
        icon="pi pi-th-large"
        [text]="true"
        [rounded]="true"
        severity="secondary"
      ></p-button>
    </div>
  </ng-template>

  <ng-template zTemplate="body">
    <ng-content></ng-content>
  </ng-template>
</zaeper-dashboard-layout>
